import React, { useState, useEffect } from "react";
import { Gallery } from "react-grid-gallery";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Emailvalidate,
  Otpvalidation,
  ImageShare2ndVersion,
} from "../../DAM_API/urls";
import cengage_white_logo from "../../assets/V2-images/cengage_white_logo.svg";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import CommonCollection from "../../Common/Designs/CommonCollection";
import { CommonSvg } from "../../Common/SVG";
import { selectRangeByUUID } from "../folder/Innerfolder";
import CommonAuthPopup from "../../Common/CommonAuthPopup";
import { useDownloadAssets } from "../../../context/DownloadAssetsContext";
import Axios from "../../../utils/Axios";

function InnerCollection() {
  const { id, comSlug } = useParams();
  const location = useLocation();
  const [images, setImages] = useState([]);
  const [collection, setCollection] = useState();
  const [showemail, setShowEmail] = useState(false);
  const [addCollection, setAddCollection] = useState(true);
  const [otpshow, setOtpshow] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [selectedCount, setSelectedCount] = useState(0);
  const [prevIndexSelected, setPrevIndexSelected] = useState();
  const [filterState, setFilterState] = useState({});
  const [siteloading, setSiteLoading] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [popupMode, setPopupMode] = useState("email");
  const [buttonLoading, setButtonLoading] = useState(false);
  const { startDownload } = useDownloadAssets();

  const navigate = useNavigate();

  const ShareImage = async (id) => {
    setSiteLoading(true);
    if (
      filterState?.searchInput?.length > 0 &&
      filterState?.searchInput?.length < 3
    ) {
      return;
    }
    const _data = {
      shareUniqueId: id,
      ...(filterState?.searchInput && {
        searchKeyword: filterState?.searchInput,
      }),
      email: email.toLowerCase(),
      otp: otp,
    };

    //searchText
    try {
      const response = await Axios.post(ImageShare2ndVersion, _data, {
        headers: {
          "Content-Type": "application/json", // make sure backend expects JSON
        },
      });

      setCollection(response?.data?.data?.collections);

      setIsFirstLoad(false);
      setShowEmail(response.data.success);
      setSiteLoading(false);
    } catch (error) {
      console.error("Error fetching image:", error);
      setShowEmail(error?.response?.data?.success);
      setIsFirstLoad(false);

      setSiteLoading(false);
    }
  };

  const handleOtp = async () => {
    try {
      setButtonLoading(true);

      const response = await Axios.post(Emailvalidate, {
        email,
        uniqueId: id,
      });

      if (
        response.data.data === "Asset is OTP protected. Check your mail for OTP"
      ) {
        setPopupMode("otp");
      } else {
        setPopupMode(null);
        setShowEmail(true);
        ShareImage(id);
      }
    } catch (error) {
      toast.error(error.response.data.data);
      setButtonLoading(false);
    } finally {
      setButtonLoading(false);
    }
  };

  const sendOtp = async () => {
    try {
      setButtonLoading(true);

      const response = await Axios.post(Otpvalidation, {
        shareUniqueId: id,
        otp,
        email,
      });

      if (response.data) {
        setCollection(response?.data?.data?.collections);
        setPopupMode(null);
        setShowEmail(true);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      setButtonLoading(false);
    } finally {
      setButtonLoading(false);
    }
  };

  const handleSelect = (index) => {
    const nextImages = images.map((image, i) =>
      i === index ? { ...image, isSelected: !image.isSelected } : image,
    );
    setImages(nextImages);
    setSelectedCount(nextImages.filter((image) => image.isSelected).length);
  };

  const downloadHandler = async () => {
    try {
      const _data = {
        collectionId: collection
          .filter((item) => item?.isSelected)
          ?.map((item) => item?.collectionID),
      };
      const response = await startDownload(_data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (id) {
      ShareImage(id);
    }
  }, [filterState, id]);
  if (siteloading && isFirstLoad) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          width: "400px",
          zIndex: 1000,
        }}
      >
        Loading...
      </div>
    );
  }

  return (
    <>
      {showemail === true ? (
        <>
          <div
            className="container"
            style={{
              marginTop: "80px",
            }}
          >
            <div className="d-flex justify-content-between">
              <div
                className="d-flex justify-content-between"
                style={{
                  marginBottom: "2px",
                }}
              >
                <div>
                  <h2>Collection</h2>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                {collection?.some((item) => item?.isSelected) && (
                  <div>
                    {" "}
                    <button
                      className="Primary-Button"
                      onClick={downloadHandler}
                    >
                      Download
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-end">
                <div className="d-flex search-box align-items-center">
                  <div
                    style={{
                      marginLeft: "0.5rem",
                    }}
                  >
                    {CommonSvg.searchIconSvg}
                  </div>
                  <input
                    type="search"
                    placeholder="Search Collection"
                    value={filterState?.searchInput || ""}
                    onChange={(e) => {
                      setFilterState((prev) => ({
                        ...prev,
                        searchInput: e.target.value,
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="p-t-1 p-b-1"></div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                {collection?.map((item, index) => (
                  <CommonCollection
                    key={index}
                    Data={item}
                    EllipseActions={CommonSvg.downloadIconsSvg}
                    isSelected={item.isSelected}
                    HandleSelect={(value) => {
                      if (value?.Key === 3) {
                        const returnedValueData = selectRangeByUUID(
                          collection,
                          prevIndexSelected,
                          item?.collectionID,
                          "collectionID",
                        );
                        setCollection(returnedValueData);
                      }

                      if (value?.Key === 1) {
                        setPrevIndexSelected(item?.collectionID);
                        setCollection((prev) =>
                          prev.map(
                            (_item) =>
                              _item?.collectionID === item?.collectionID
                                ? { ..._item, isSelected: !_item?.isSelected } // toggle only clicked item
                                : { ..._item, isSelected: false }, // deselect others
                          ),
                        );
                      }

                      if (value?.Key === 2) {
                        setPrevIndexSelected(item?.collectionID);
                        setCollection((prev) =>
                          prev.map(
                            (_item) =>
                              _item?.collectionID === item?.collectionID
                                ? { ..._item, isSelected: !_item?.isSelected } // toggle clicked one
                                : _item, // leave others as-is
                          ),
                        );
                      }
                    }}
                    HanldeTwiceClick={() => {
                      navigate(
                        `/${comSlug}/collection/view/${item?.collectionID}`,
                      );
                    }}
                  />
                ))}
              </div>

              <Gallery
                images={images}
                enableImageSelection={true}
                onSelect={handleSelect}
              />
            </div>
          </div>
          <div className="position">
            <div className="d-flex gap-3 align-items-center justify-content-end foot">
              <div className="powerd">Powered by</div>
              <img src={cengage_white_logo} className="cengageimg" />
            </div>
          </div>
        </>
      ) : (
        <>
          <CommonAuthPopup
            isOpen={!!popupMode}
            mode={popupMode}
            email={email}
            setEmail={setEmail}
            otp={otp}
            setOtp={setOtp}
            onSubmit={popupMode === "email" ? handleOtp : sendOtp}
            onClose={() => setPopupMode(null)}
            buttonLoading={buttonLoading}
          />
        </>
      )}
    </>
  );
}

export default InnerCollection;
